import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useContext } from "react";
import { GTMProjectContext } from "../GTMProjectContext";
import { SAVE_GTM_PROJECT } from "../graphql";

const ActionsView = () => {
  const { originalGTMProject } = useContext(GTMProjectContext);

  const [saveProject, saveProjectRes] = useMutation(SAVE_GTM_PROJECT, {
    onCompleted() {
      Alert("success", "Project saved successfully");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });
  const [resetState, resetStateRes] = useMutation(SAVE_GTM_PROJECT, {
    onCompleted() {
      Alert("success", "Project reset successfully");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function updateStage(state) {
    if (
      window.confirm(
        `Are you sure you want to move this project to ${state} stage?`,
      )
    ) {
      saveProject({
        variables: { id: originalGTMProject.id, state },
      });
    }
  }

  function resetStage(state) {
    if (
      window.confirm(
        `Are you sure you want to reset this project to the ${state} stage?`,
      )
    ) {
      resetState({
        variables: { id: originalGTMProject.id, resetToState: state },
      });
    }
  }

  return (
    <div className="card">
      <h5>Status</h5>

      <div className="mt-2">
        {originalGTMProject.state === "PACKAGING" && (
          <div className="space-y-4">
            <div>
              This project is currently in the <b>PACKAGING</b> stage. To
              proceed to the next phase, please ensure that `PRODUCT`,
              'PACKAGING' and `COMPLIANCE` are confirmed.
            </div>

            <div className="mt-4">
              <Button
                onClick={() => updateStage("TRIAL_ORDER")}
                loading={saveProjectRes.loading}
                disabled={
                  !originalGTMProject.productConfirmedAt ||
                  !originalGTMProject.packagingConfirmedAt ||
                  !originalGTMProject.complianceConfirmedAt
                }
              >
                Start Trial Order
              </Button>
            </div>
          </div>
        )}

        {originalGTMProject.state === "TRIAL_ORDER" && (
          <div>
            <div>
              This project is currently in the Trial Order stage. You can start
              to place trial order for this product. Once the trial orders are
              placed and ready to release, you can move this project to the
              Internal Release stage.
            </div>

            <div className="mt-4 flex space-x-6">
              <Button
                disabled={!originalGTMProject.trialOrderConfirmedAt}
                onClick={() => updateStage("READY_FOR_ORDERS")}
                loading={saveProjectRes.loading}
              >
                Ready for Orders
              </Button>
              <Button
                danger
                onClick={() => resetStage("PACKAGING")}
                loading={resetStateRes.loading}
              >
                Reset Packaging
              </Button>
            </div>
          </div>
        )}

        {originalGTMProject.state === "READY_FOR_ORDERS" && (
          <div>
            <div>This project is currently in the Ready for Orders stage.</div>

            <div className="mt-4 space-y-2">
              <Button onClick={() => updateStage("PUBLIC_RELEASE")} disabled>
                Public Release
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionsView;
